module.exports = __webpack_public_path__ + "img/box.c5f2cddb.svg";